/* Meyvelodi tema betiği. Her bileşen kendi kök öğesini arar; bölüm sayfada yoksa sessizce atlanır. */
(function () {
  'use strict';
  var D = document;
  function q(s, r) { return (r || D).querySelector(s); }
  function qa(s, r) { return [].slice.call((r || D).querySelectorAll(s)); }
  function bir(el, ad) { if (!el || el.getAttribute('data-mv-hazir-' + ad)) return false; el.setAttribute('data-mv-hazir-' + ad, '1'); return true; }
  var azHareket = window.matchMedia && matchMedia('(prefers-reduced-motion:reduce)').matches;
  var KOK = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  function tl(kurus) {
    kurus = Math.round(kurus);
    var lira = Math.floor(kurus / 100), kr = kurus % 100;
    var s = String(lira).replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    return '₺' + s + (kr ? ',' + (kr < 10 ? '0' : '') + kr : '');
  }

  var toastZ;
  function toast(m) {
    var t = D.getElementById('toast'); if (!t) return;
    t.textContent = m; t.classList.add('acik'); clearTimeout(toastZ);
    toastZ = setTimeout(function () { t.classList.remove('acik'); }, 3200);
  }

  /* ---------------- ses ---------------- */
  var F = { C4: 261.63, D4: 293.66, E4: 329.63, F4: 349.23, G4: 392, A4: 440, B4: 493.88, C5: 523.25, D5: 587.33, 'D#5': 622.25, E5: 659.25 };
  var ADIM = { C4: -2, D4: -1, E4: 0, F4: 1, G4: 2, A4: 3, B4: 4, C5: 5, D5: 6, 'D#5': 6, E5: 7 };
  var SARKILAR = [
    { ad: 'Daha Dün Annemizin', n: 'G4 G4 D5 D5 E5 E5 D5 C5 C5 B4 B4 A4 A4 G4'.split(' ') },
    { ad: 'Neşeye Övgü', n: 'B4 B4 C5 D5 D5 C5 B4 A4 G4 G4 A4 B4 B4 A4 A4'.split(' ') },
    { ad: 'Für Elise', n: 'E5 D#5 E5 D#5 E5 B4 D5 C5 A4'.split(' ') }
  ];
  var ctx = null;
  function ses(f) {
    try {
      ctx = ctx || new (window.AudioContext || window.webkitAudioContext)();
      if (ctx.state === 'suspended') ctx.resume();
      var t = ctx.currentTime, ana = ctx.createGain();
      ana.gain.setValueAtTime(0.0001, t); ana.gain.exponentialRampToValueAtTime(0.32, t + 0.012); ana.gain.exponentialRampToValueAtTime(0.0001, t + 1.1);
      ana.connect(ctx.destination);
      [[1, 'triangle', 1], [2, 'sine', 0.4], [3.01, 'sine', 0.12]].forEach(function (p) {
        var o = ctx.createOscillator(), g = ctx.createGain(); o.type = p[1]; o.frequency.value = f * 2 * p[0]; g.gain.value = p[2];
        o.connect(g); g.connect(ana); o.start(t); o.stop(t + 1.15);
      });
    } catch (e) { }
  }
  /* Dokununca melodinin tamamı kendiliğinden çalar (gerçek üründeki gibi). */
  var MELODI = SARKILAR[0].n, calanZ = null;
  function melodiCal(herNota, bitince) {
    clearTimeout(calanZ); var i = 0;
    (function sira() {
      ses(F[MELODI[i]]); if (herNota) herNota(i); i++;
      if (i < MELODI.length) calanZ = setTimeout(sira, (i % 7 === 0) ? 640 : 330);
      else calanZ = setTimeout(function () { calanZ = null; if (bitince) bitince(); }, 700);
    })();
  }
  function caliyorMu() { return calanZ !== null; }
  var ELLER = { muz: [[46, 322], [342, 314]], cilek: [[30, 268], [446, 268]], havuc: [[66, 264], [374, 264]] };

  function notaUcur(kap, xo, yo) {
    var w = kap.clientWidth, h = kap.clientHeight;
    var el = D.createElementNS('http://www.w3.org/2000/svg', 'svg');
    el.setAttribute('class', 'ucan' + (Math.random() < 0.4 ? ' m' : '')); el.setAttribute('viewBox', '0 0 34 34');
    el.innerHTML = '<use href="#s-nota"/>';
    var x0 = w * xo - 17, y0 = h * yo - 17;
    el.style.setProperty('--x0', x0 + 'px'); el.style.setProperty('--y0', y0 + 'px');
    el.style.setProperty('--x1', (x0 + 30 + Math.random() * 70) + 'px'); el.style.setProperty('--y1', (y0 - 85 - Math.random() * 55) + 'px');
    el.style.setProperty('--r', (Math.random() * 50 - 10) + 'deg');
    kap.appendChild(el); setTimeout(function () { el.remove(); }, 1300);
  }

  /* ---------------- ana görsel: dokun, çal + porte ---------------- */
  function heroKur(kok) {
    if (!bir(kok, 'hero')) return;
    var dugme = q('[data-muz]', kok), cizgiler = q('[data-cizgiler]', kok), durum = q('[data-porte-durum]', kok), sayac = q('[data-nota-sayac]', kok), yazi = q('[data-dene-yazi]', kok), sahne = q('.sahne', kok);
    if (!dugme) return;
    var ilkYazi = yazi ? yazi.textContent : '';
    function yaz(ad) { if (durum) durum.textContent = durum.getAttribute('data-' + ad) || ''; }
    function kur() {
      if (sayac) sayac.textContent = '0 / ' + MELODI.length;
      if (!cizgiler) return;
      cizgiler.innerHTML = '';
      MELODI.forEach(function (k, n) {
        var e = D.createElement('i'), a = ADIM[k];
        e.className = 'n' + (a >= 4 ? ' asagi' : '') + (a === -2 ? ' ek' : '');
        e.style.left = ((n + 0.7) / (MELODI.length + 0.4) * 100) + '%';
        e.style.top = (76 - a * 6 + 1) + 'px';
        cizgiler.appendChild(e);
      });
    }
    dugme.addEventListener('click', function () {
      dugme.classList.remove('dokundu'); void dugme.offsetWidth; dugme.classList.add('dokundu');
      if (caliyorMu()) return;
      kur(); yaz('caliyor'); kok.classList.add('caliyor');
      if (yazi) yazi.textContent = durum ? (durum.getAttribute('data-caliyor') || ilkYazi) : ilkYazi;
      melodiCal(function (n) {
        if (cizgiler) { var h = cizgiler.children; if (n > 0) h[n - 1].classList.remove('son'); h[n].classList.add('calindi', 'son'); }
        if (sayac) sayac.textContent = (n + 1) + ' / ' + MELODI.length;
        var el = ELLER.muz[n % 2]; if (sahne && !azHareket) notaUcur(sahne, el[0] / 480, el[1] / 600);
      }, function () { yaz('bitti'); kok.classList.remove('caliyor'); if (yazi) yazi.textContent = ilkYazi; });
    });
    kur();
  }

  /* ---------------- ana sayfa sipariş bölümü ---------------- */
  function teklifKur(kok) {
    if (!bir(kok, 'teklif')) return;
    var cta = q('[data-teklif-cta]', kok), url = kok.getAttribute('data-url') || '';
    if (!cta || !url) return;
    qa('input[type=radio]', kok).forEach(function (r) {
      r.addEventListener('change', function () { cta.href = url + (url.indexOf('?') > -1 ? '&' : '?') + 'adet=' + r.value; });
    });
  }

  /* ---------------- ürün sayfası ---------------- */
  function urunKur(kok) {
    if (!bir(kok, 'urun')) return;
    var veriEl = q('[data-urun-veri]', kok); if (!veriEl) return;
    var V; try { V = JSON.parse(veriEl.textContent); } catch (e) { return; }
    var vs = V.varyantlar || []; if (!vs.length) return;
    var vitrin = q('[data-vitrin]', kok), minik = q('[data-gminiler]', kok);
    var ilkKap = q('[data-secim-ilk]', kok), ekKap = q('[data-secim-ek]', kok), ekAlan = q('[data-ek-alan]', kok);
    var cta = q('[data-siparis]', kok), ozetEl = q('[data-ozet]', kok), fiyatEl = q('[data-fiyat]', kok), eskiEl = q('[data-eski]', kok);
    var stoklu = vs.map(function (v, i) { return v.stok ? i : -1; }).filter(function (i) { return i > -1; });
    var hepsiTukendi = !stoklu.length;
    if (hepsiTukendi) stoklu = [0];

    var adet = 1, secim = [stoklu[0], stoklu[1 % stoklu.length], stoklu[2 % stoklu.length]], aktif = secim[0];
    try {
      var p = new URLSearchParams(location.search), a = parseInt(p.get('adet'), 10), vid = p.get('variant');
      if (a >= 1 && a <= 3) adet = a;
      if (vid) vs.forEach(function (v, i) { if (String(v.id) === vid && v.stok) { secim[0] = i; aktif = i; } });
    } catch (e) { }

    function toplam() {
      var t = 0, e = 0, n;
      for (n = 0; n < adet; n++) { var v = vs[secim[n]]; t += v.fiyat; e += (v.eski > v.fiyat ? v.eski : v.fiyat); }
      var paket = V.paket && V.paket[String(adet)];
      if (adet > 1 && paket > 0 && paket < t) t = paket;
      return { t: t, e: e > t ? e : 0 };
    }
    function ozet() {
      var s = {}, sira = [];
      secim.slice(0, adet).forEach(function (i) { if (!s[i]) { s[i] = 0; sira.push(i); } s[i]++; });
      return sira.map(function (i) { return s[i] + ' ' + vs[i].ad.toLocaleLowerCase('tr'); }).join(', ');
    }
    function satir(n) {
      var h = '<div class="secim-satir' + (n === 0 ? ' tek' : '') + '"><span>' + (n + 1) + '. ' + (V.sira || '') + '</span><div class="cipler" role="radiogroup">';
      vs.forEach(function (v, i) {
        h += '<label class="cip ' + v.anahtar + (v.stok ? '' : ' tukendi') + '"><input type="radio" name="mv-v' + n + '" value="' + i + '" data-n="' + n + '"' + (secim[n] === i ? ' checked' : '') + (v.stok ? '' : ' disabled') + '><svg aria-hidden="true"><use href="#s-' + v.anahtar + '"/></svg>' + v.ad.replace(/</g, '&lt;') + '</label>';
      });
      return h + '</div></div>';
    }
    function satirlar() {
      if (ilkKap) ilkKap.innerHTML = satir(0);
      if (ekKap) { var h = '', n; for (n = 1; n < adet; n++) h += satir(n); ekKap.innerHTML = h; }
      if (ekAlan) ekAlan.hidden = adet === 1;
    }
    var medyaModu = vitrin && vitrin.classList.contains('medya-modu'), slaytlar = medyaModu ? qa('.medya', vitrin) : [];
    function medyaIsaretle(n) {
      slaytlar.forEach(function (e, i) { e.classList.toggle('acik', i === n); if (i !== n) qa('video', e).forEach(function (v) { v.pause(); }); });
      var sira = q('[data-galeri-sira]', kok); if (sira) sira.textContent = n + 1;
      if (slaytlar[n]) vitrin.setAttribute('data-k', slaytlar[n].getAttribute('data-k'));
      if (minik) qa('.gmini', minik).forEach(function (b, i) {
        b.setAttribute('aria-current', i === n ? 'true' : 'false');
        if (i === n) minik.scrollTo({ left: b.offsetLeft - (minik.clientWidth - b.offsetWidth) / 2, behavior: azHareket ? 'auto' : 'smooth' });
      });
    }
    function medyaGit(n, aninda) {
      n = Math.max(0, Math.min(slaytlar.length - 1, n)); if (!slaytlar[n]) return;
      vitrin.scrollTo({ left: slaytlar[n].offsetLeft, behavior: (aninda || azHareket) ? 'auto' : 'smooth' }); medyaIsaretle(n);
    }
    function medyaSira() { return Math.round(vitrin.scrollLeft / Math.max(1, vitrin.clientWidth)); }
    if (medyaModu) {
      var kz; vitrin.addEventListener('scroll', function () { clearTimeout(kz); kz = setTimeout(function () { medyaIsaretle(medyaSira()); }, 80); }, { passive: true });
      var og = q('[data-galeri-geri]', kok), oi = q('[data-galeri-ileri]', kok);
      if (og) og.addEventListener('click', function () { medyaGit(medyaSira() - 1); });
      if (oi) oi.addEventListener('click', function () { medyaGit(medyaSira() + 1); });
    }
    function kare(k) {
      if (!vitrin) return;
      if (medyaModu) { slaytlar.forEach(function (e, i) { if (e.getAttribute('data-k') == k) medyaGit(i); }); return; }
      vitrin.setAttribute('data-k', k);
      qa('.kare,.medya', vitrin).forEach(function (e) {
        var ac = e.getAttribute('data-k') == k; e.classList.toggle('acik', ac);
        if (!ac) qa('video', e).forEach(function (v) { v.pause(); });
      });
      if (minik) qa('.gmini', minik).forEach(function (b) { b.setAttribute('aria-current', b.getAttribute('data-git') == k ? 'true' : 'false'); });
    }
    function guncelle() {
      var v = vs[aktif], f = toplam();
      if (vitrin) vitrin.setAttribute('data-v', v.anahtar);
      if (minik) minik.setAttribute('data-v', v.anahtar);
      qa('[data-mini-v]', kok).forEach(function (u) { u.setAttribute('href', '#s-' + v.anahtar); });
      qa('.paket .adet', kok).forEach(function (k) { qa('use', k).forEach(function (u, n) { u.setAttribute('href', '#s-' + vs[secim[n]].anahtar); }); });
      if (ozetEl) ozetEl.textContent = ozet();
      if (fiyatEl) fiyatEl.textContent = tl(f.t);
      if (eskiEl) { eskiEl.hidden = !f.e; if (f.e) eskiEl.textContent = tl(f.e); }
      if (cta && !hepsiTukendi) cta.textContent = (V.etiket || 'Sipariş ver') + ', ' + tl(f.t);
      qa('[data-cubuk-tutar]').forEach(function (e) { e.textContent = tl(f.t); });
      qa('[data-karakter-baslik]').forEach(function (e) { e.textContent = v.ad + ' ' + (e.getAttribute('data-sonek') || ''); });
      var su = q('[data-stok-uyari]', kok);
      if (su) {
        var az = V.stok_esik > 0 && v.takip && v.stok && v.adet > 0 && v.adet <= V.stok_esik;
        su.hidden = !az;
        if (az) q('span', su).textContent = (su.getAttribute('data-yazi') || '').replace('[adet]', v.adet).replace('[karakter]', v.ad);
      }
    }

    qa('input[name=paket]', kok).forEach(function (r) {
      if (+r.value === adet) r.checked = true;
      r.addEventListener('change', function () {
        adet = +r.value;
        if (secim.slice(0, adet).indexOf(aktif) < 0) aktif = secim[0];
        satirlar(); guncelle();
      });
    });
    function secildi(e) {
      var r = e.target; if (!r || r.getAttribute('data-n') === null) return;
      secim[+r.getAttribute('data-n')] = +r.value; aktif = +r.value;
      if (V.cizim) kare('urun'); else if (vs[aktif].medya) kare(vs[aktif].medya);
      guncelle();
    }
    if (ilkKap) ilkKap.addEventListener('change', secildi);
    if (ekKap) ekKap.addEventListener('change', secildi);
    if (minik) qa('.gmini', minik).forEach(function (b) { b.addEventListener('click', function () { kare(b.getAttribute('data-git')); }); });
    satirlar(); guncelle();
    if (medyaModu) { var ilkM = vs[aktif].medya, ilkN = 0; slaytlar.forEach(function (e, i) { if (ilkM && e.getAttribute('data-k') == ilkM) ilkN = i; }); medyaGit(ilkN, true); }

    /* galerideki peluşa dokun: melodi baştan sona çalar */
    var muz = q('[data-muz]', kok), yazi = q('[data-dene-yazi]', kok), ilkYazi = yazi ? yazi.textContent : '';
    if (muz) muz.addEventListener('click', function () {
      muz.classList.remove('dokundu'); void muz.offsetWidth; muz.classList.add('dokundu');
      if (caliyorMu()) return;
      if (yazi) yazi.textContent = 'Çalıyor';
      melodiCal(function (n) {
        var el = (ELLER[vs[aktif].anahtar] || ELLER.muz)[n % 2];
        if (vitrin && !azHareket) notaUcur(vitrin, (79 + el[0] * 0.92) / 600, (22 + el[1] * 0.92) / 600);
      }, function () { if (yazi) yazi.textContent = ilkYazi; });
    });

    /* sipariş: seçilen karakterleri sepete koy, ödeme sayfasına git */
    if (cta) cta.addEventListener('click', function () {
      if (hepsiTukendi || cta.disabled) return;
      var say = {}, items = [];
      secim.slice(0, adet).forEach(function (i) { say[vs[i].id] = (say[vs[i].id] || 0) + 1; });
      Object.keys(say).forEach(function (id) { items.push({ id: +id, quantity: say[id] }); });
      cta.disabled = true; cta.setAttribute('data-eski', cta.textContent); if (V.gidiyor) cta.textContent = V.gidiyor;
      var bas = { 'Content-Type': 'application/json', 'Accept': 'application/json' };
      fetch(KOK + 'cart/clear.js', { method: 'POST', headers: bas, credentials: 'same-origin' })
        .then(function () { return fetch(KOK + 'cart/add.js', { method: 'POST', headers: bas, credentials: 'same-origin', body: JSON.stringify({ items: items }) }); })
        .then(function (r) { if (!r.ok) throw new Error('sepet'); location.href = KOK + (V.hedef === 'cart' ? 'cart' : 'checkout'); })
        .catch(function () { cta.disabled = false; guncelle(); toast(V.hata || 'Bir sorun oldu, lütfen tekrar dene.'); });
    });
    /* ödeme sayfasından geri dönülünce (bfcache) düğme kilitli kalmasın */
    window.addEventListener('pageshow', function () { if (cta && !hepsiTukendi) { cta.disabled = false; guncelle(); } });
  }

  /* ---------------- kayan videolar ---------------- */
  function videolarKur(kok) {
    if (!bir(kok, 'video')) return;
    var serit = q('[data-vid-serit]', kok); if (!serit) return;
    var kartlar = qa('.vid', serit), sesli = null, demoT = null, demoI = 0;
    var yAc = kok.getAttribute('data-ses-ac') || 'Sesi aç', yAcik = kok.getAttribute('data-ses-acik') || 'Ses açık';
    function demoDur() { clearInterval(demoT); demoT = null; }
    function demoBasla() { demoDur(); var m = SARKILAR[0].n; ses(F[m[0]]); demoI = 1; demoT = setInterval(function () { ses(F[m[demoI % m.length]]); demoI++; }, 430); }
    function video(k) { return k.classList.contains('gercek') ? q('video', k) : null; }
    function etiket(k, acik) {
      var b = q('.vid-dugme', k), ad = b.getAttribute('data-ad') || 'Video', y = q('[data-ses-yazi]', k);
      b.setAttribute('aria-pressed', acik ? 'true' : 'false'); b.setAttribute('aria-label', ad + ': ' + (acik ? yAcik : yAc));
      if (y) y.textContent = acik ? yAcik : yAc;
    }
    function sustur(k) {
      k.classList.remove('sesli'); var v = video(k); if (v) v.muted = true; else if (sesli === k) demoDur();
      etiket(k, false); if (sesli === k) sesli = null;
    }
    function sesAc(k) {
      if (sesli && sesli !== k) sustur(sesli);
      sesli = k; k.classList.add('sesli', 'oynuyor'); var v = video(k);
      if (v) { v.muted = false; var p = v.play(); if (p && p.catch) p.catch(function () { }); } else demoBasla();
      etiket(k, true);
    }
    kartlar.forEach(function (k) {
      var v = q('video', k), src = k.getAttribute('data-src');
      if (src && v) {
        v.src = src; if (k.getAttribute('data-poster')) v.poster = k.getAttribute('data-poster'); k.classList.add('gercek');
        v.addEventListener('timeupdate', function () { if (v.duration) q('.ilerleme i', k).style.width = (v.currentTime / v.duration * 100) + '%'; });
      }
      q('.vid-dugme', k).addEventListener('click', function () { if (sesli === k) sustur(k); else sesAc(k); });
    });
    /* Ekrandaysa SESSİZ oynat; ekrandan çıkınca durdur ve sesi kapat. Kaydırma hiçbir zaman ses açmaz. */
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (es) {
        es.forEach(function (e) {
          var k = e.target, v = video(k);
          if (e.isIntersecting && e.intersectionRatio >= 0.6) {
            if (!azHareket) { k.classList.add('oynuyor'); if (v) { v.muted = (sesli !== k); var p = v.play(); if (p && p.catch) p.catch(function () { }); } }
          } else { k.classList.remove('oynuyor'); if (v) v.pause(); if (sesli === k) sustur(k); }
        });
      }, { threshold: [0, 0.6] });
      kartlar.forEach(function (k) { io.observe(k); });
    }
    D.addEventListener('visibilitychange', function () { if (D.hidden && sesli) sustur(sesli); });
    function kaydir(y) { var k = kartlar[0]; if (k) serit.scrollBy({ left: y * (k.offsetWidth + 16), behavior: azHareket ? 'auto' : 'smooth' }); }
    var g = q('[data-geri]', kok), i = q('[data-ileri]', kok);
    if (g) g.addEventListener('click', function () { kaydir(-1); });
    if (i) i.addEventListener('click', function () { kaydir(1); });
  }

  /* ---------------- tahmini teslimat + kargo sayacı ---------------- */
  var AY = ['Ocak', 'Şubat', 'Mart', 'Nisan', 'Mayıs', 'Haziran', 'Temmuz', 'Ağustos', 'Eylül', 'Ekim', 'Kasım', 'Aralık'];
  function ayar(ad, yedek) { var n = parseInt(D.body.getAttribute(ad), 10); return isNaN(n) ? yedek : n; }
  function ileri(d, n) { var x = new Date(d); while (n > 0) { x.setDate(x.getDate() + 1); if (x.getDay() !== 0) n--; } return x; }
  function teslimKur() {
    var kesim = ayar('data-kesim', 16), mn = ayar('data-gun-min', 1), mx = Math.max(ayar('data-gun-max', 3), mn);
    var s = new Date(), cikis = new Date(s);
    if (s.getDay() === 0 || s.getHours() >= kesim) cikis = ileri(s, 1);
    var a = ileri(cikis, mn), b = ileri(cikis, mx);
    var aralik = a.getTime() === b.getTime() ? a.getDate() + ' ' + AY[a.getMonth()]
      : (a.getMonth() === b.getMonth() ? a.getDate() + ' ile ' + b.getDate() + ' ' + AY[b.getMonth()] : a.getDate() + ' ' + AY[a.getMonth()] + ' ile ' + b.getDate() + ' ' + AY[b.getMonth()]);
    var bugun = cikis.toDateString() === s.toDateString();
    qa('[data-teslim]').forEach(function (e) { e.textContent = aralik; });
    qa('[data-cikis]').forEach(function (e) { e.textContent = bugun ? 'Bugün, ' + kesim + ':00 sonrası' : cikis.getDate() + ' ' + AY[cikis.getMonth()]; });
  }
  var sayacZ;
  function iki(n) { return (n < 10 ? '0' : '') + n; }
  function sayacKur() {
    var kaplar = qa('[data-mv-sayac]'), kampanyalar = qa('[data-kampanya]'); if (!kaplar.length && !kampanyalar.length) return;
    var kesim = ayar('data-kesim', 16);
    var bitisler = kampanyalar.map(function (k) { var t = (k.getAttribute('data-kampanya') || '').trim().replace(' ', 'T'); var z = new Date(t.length <= 10 ? t + 'T23:59:59' : t); return isNaN(z) ? null : z; });
    function say() {
      var s = new Date(), h = new Date(); h.setHours(kesim, 0, 0, 0);
      var pazar = s.getDay() === 0, yarin = pazar || s >= h;
      if (yarin) { h.setDate(h.getDate() + 1); if (h.getDay() === 0) h.setDate(h.getDate() + 1); }
      var f = Math.max(0, Math.floor((h - s) / 1000)), sure = iki(Math.floor(f / 3600)) + ':' + iki(Math.floor(f % 3600 / 60)) + ':' + iki(f % 60);
      var ertesiGun = new Date(s); ertesiGun.setDate(s.getDate() + 1);
      var pazartesiye = yarin && h.toDateString() !== ertesiGun.toDateString();
      kaplar.forEach(function (kap) {
        var yazi = q('[data-sayac-yazi]', kap), b = q('[data-sayac]', kap);
        var metin = kap.getAttribute(yarin ? 'data-yarin' : 'data-bugun') || '';
        if (pazartesiye) metin = metin.replace('Yarın', 'Pazartesi').replace('yarın', 'pazartesi');
        if (yazi) yazi.textContent = metin;
        /* geri sayım yalnızca bugün kargoya yetişme şansı varken gösterilir */
        if (b) { b.textContent = yarin ? '' : sure; b.hidden = yarin; }
      });
      kampanyalar.forEach(function (k, n) {
        var z = bitisler[n], kalan = z ? Math.floor((z - s) / 1000) : 0;
        if (!z || kalan <= 0) { k.hidden = true; return; }
        var g = Math.floor(kalan / 86400), b = q('[data-kampanya-sure]', k);
        if (b) b.textContent = (g > 0 ? g + ' gün ' : '') + iki(Math.floor(kalan % 86400 / 3600)) + ':' + iki(Math.floor(kalan % 3600 / 60)) + ':' + iki(kalan % 60);
        k.hidden = false;
      });
    }
    clearInterval(sayacZ); say(); sayacZ = setInterval(say, 1000);
  }

  /* ---------------- mobil yapışkan çubuk ---------------- */
  var cubukIO;
  function cubukKur() {
    var cubuk = q('[data-mv-cubuk]'); if (!cubuk) return;
    var hedefler = qa('[data-cubuk-gizle]');
    if (!('IntersectionObserver' in window) || !hedefler.length) { cubuk.classList.add('acik'); return; }
    if (cubukIO) cubukIO.disconnect();
    var gor = new Map();
    cubukIO = new IntersectionObserver(function (es) {
      es.forEach(function (e) { gor.set(e.target, e.isIntersecting); });
      var biriGorunur = false; gor.forEach(function (v) { if (v) biriGorunur = true; });
      cubuk.classList.toggle('acik', !biriGorunur);
    });
    hedefler.forEach(function (h) { cubukIO.observe(h); });
  }

  /* ---------------- başlat ---------------- */
  function baslat(kap) {
    kap = kap || D;
    qa('[data-mv-hero]', kap).forEach(heroKur);
    qa('[data-mv-teklif]', kap).forEach(teklifKur);
    qa('[data-mv-urun]', kap).forEach(urunKur);
    qa('[data-mv-videolar]', kap).forEach(videolarKur);
    teslimKur(); sayacKur(); cubukKur();
  }
  if (D.readyState === 'loading') D.addEventListener('DOMContentLoaded', function () { baslat(); }); else baslat();
  /* tema düzenleyicisinde bölüm yeniden yüklenince */
  D.addEventListener('shopify:section:load', function (e) { baslat(e.target); });
})();
